import { useApplicationStore } from '@data';
import { VisitMethod } from '@qmd-types/visits';
import { useShallow } from 'zustand/shallow';

export const useIsInPersonVisit = () => {
  return useApplicationStore(
    useShallow((state) => {
      const visit = state.getVisitTypeById(state.visitTypeId || '');
      const patientVisitDetail = state.patient.visitDetail;

      const isInPersonVisit = visit
        ? visit.isInPerson
        : patientVisitDetail
          ? patientVisitDetail.method === VisitMethod.INPERSON
          : false;

      const isInPersonVisitRequired = !!state.getServiceTypeByVisitTypeId(
        state.visitTypeId || '',
      )?.isInPersonVisitRequired;

      return {
        isInPersonVisit: !!isInPersonVisit,
        isInPersonVisitRequired,
      };
    }),
  );
};
